
import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import NavLinks from './navigation/NavLinks';
import MobileSidebar from './navigation/MobileSidebar';
import BurgerButton from './navigation/BurgerButton';
import { UserMenu } from './navigation/UserMenu';
import SearchBarContainer from './navigation/SearchBarContainer';
import { useIsMobile } from '@/hooks/use-mobile';
import { throttle } from '@/lib/utils';

const SIDEBAR_TOGGLE_THROTTLE_MS = 300;

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const navigate = useNavigate();
  const { user, profile, signOut } = useAuth();
  const isMobile = useIsMobile();

  const toggleSidebar = useMemo(
    () =>
      throttle(() => {
        setIsSidebarOpen((prev) => !prev);
      }, SIDEBAR_TOGGLE_THROTTLE_MS),
    []
  );

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <>
      <nav className="sticky top-0 z-50 bg-white border-b border-brand-border shadow-brand-xs pt-[env(safe-area-inset-top)]">
        <div className="container flex justify-between items-center py-3.5">
          {/* Logo */}
          <div
            className="cursor-pointer z-10 flex items-center"
            onClick={handleLogoClick}
          >
            <img
              src="/logo.svg"
              alt="FullBook"
              className="h-9 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <NavLinks />

          <div className="hidden md:flex items-center gap-3">
            {/* Desktop Search */}
            <SearchBarContainer
              isSearchExpanded={isSearchExpanded}
              setIsSearchExpanded={setIsSearchExpanded}
              isDesktop={true}
            />

            {/* User menu */}
            <div className="flex items-center gap-3 z-10">
              <UserMenu />

              <Button
                asChild
                className="bg-brand-primary hover:bg-brand-primary-600 text-white rounded-pill px-5 shadow-brand-primary transition-colors duration-200"
              >
                <Link to="/search">Réserver</Link>
              </Button>
            </div>
          </div>

          {/* Mobile: search, avatar, burger */}
          <div className="md:hidden flex items-center justify-end flex-1 gap-2">
            <SearchBarContainer
              isSearchExpanded={isSearchExpanded}
              setIsSearchExpanded={setIsSearchExpanded}
              isDesktop={false}
            />

            {user && <UserMenu />}

            <BurgerButton
              isOpen={isSidebarOpen}
              onClick={toggleSidebar}
              className="z-50"
            />
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <MobileSidebar 
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />
    </>
  );
};

export default Navbar;
